import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation';
import type { ControlProps } from '../../../Form';
import { getMultilistboxValue } from '../utils';
import getListboxContainer from './getListboxContainer';
import FilterContainer from '../FilterContainer';
import type { CommonProps } from './CommonProps';

type GetWaterSportsField = {
  searchParams: SearchParams;
  commonProps: CommonProps;
  t: TranslationFunction;
};

export const getWaterSportsOptions = ({ t, isWaiting }: { t: TranslationFunction; isWaiting?: boolean }) => [
  { value: 1, label: t('vacation.oss.filters.watersport.diving'), disabled: isWaiting },
  { value: 2, label: t('vacation.oss.filters.watersport.parasailing'), disabled: isWaiting },
  { value: 3, label: t('vacation.oss.filters.watersport.wakeboarding'), disabled: isWaiting },
  { value: 4, label: t('vacation.oss.filters.watersport.surfing'), disabled: isWaiting },
  { value: 5, label: t('vacation.oss.filters.watersport.windsurfing'), disabled: isWaiting },
  { value: 6, label: t('vacation.oss.filters.watersport.kitesurfing'), disabled: isWaiting },
];

const getWaterSportsField = ({ t, searchParams, commonProps }: GetWaterSportsField): ControlProps => {
  const { isWaiting } = commonProps;

  return getListboxContainer({
    fieldName: URLParameters.WATERSPORT,
    containerName: FilterContainer.WatersportContainer,
    containerTitle: t('vacation.oss.filters.watersport.title'),
    options: getWaterSportsOptions({ t, isWaiting }),
    value: getMultilistboxValue(searchParams[URLParameters.WATERSPORT], true),
    fieldClassName: '',
    ...commonProps,
  });
};

export default getWaterSportsField;
